import { isToolsAndBubblesHost } from '../share/serviceappBrand';

export const TB_CANONICAL_ORIGIN = 'https://www.toolsandbubbles.com';
/** Stable Google/SSO return URL — keep allow-listed in Supabase Auth → Redirect URLs. */
export const TB_OAUTH_CALLBACK_PATH = '/?auth=callback';

export function isTbApexHost(hostname: string): boolean {
  return (hostname || '').toLowerCase() === 'toolsandbubbles.com';
}

/** Redirect apex → www so PKCE verifier and callback share one origin. Returns true if redirecting. */
export function ensureTbCanonicalHost(): boolean {
  if (typeof window === 'undefined') return false;
  if (!isTbApexHost(window.location.hostname)) return false;
  window.location.replace(buildOAuthRedirectUrl());
  return true;
}

/** OAuth redirect must match where PKCE verifier is stored (always www for T&B). */
export function buildOAuthRedirectUrl(): string {
  if (typeof window === 'undefined') return TB_OAUTH_CALLBACK_PATH;

  if (isToolsAndBubblesHost(window.location.hostname)) {
    // Always return to a dedicated callback URL on www. Using the current marketing
    // path (`/`) without a marker made the app paint the public homepage before the
    // PKCE code was exchanged, so Google login looked like it "just opened home".
    return `${TB_CANONICAL_ORIGIN}${TB_OAUTH_CALLBACK_PATH}`;
  }

  const path = `${window.location.pathname}${window.location.search}`;
  return `${window.location.origin}${path || '/'}`;
}

export function hasOAuthCallbackInUrl(): boolean {
  if (typeof window === 'undefined') return false;
  const search = window.location.search;
  const hash = window.location.hash.toLowerCase();
  if (new URLSearchParams(search).has('code')) return true;
  return hash.includes('access_token=') || hash.includes('error=');
}

export function stripOAuthParamsFromUrl(): void {
  if (typeof window === 'undefined') return;
  const params = new URLSearchParams(window.location.search);
  const hadHashToken = window.location.hash.includes('access_token');
  if (!params.has('code') && !params.has('auth') && !hadHashToken) return;
  params.delete('code');
  params.delete('state');
  params.delete('auth');
  const query = params.toString();
  const next = `${window.location.pathname}${query ? `?${query}` : ''}`;
  window.history.replaceState({}, document.title, next);
}
